import {LogoTextSize} from "../../controllers/SystemUmmiaLogoTextController";
import {kInternalRoutes} from "../../constants/internalRoutes";
import SystemNeoUmmiaLogoTextImage from "../images/SystemNeoUmmiaLogoTextImage";
import {kSystemIcons} from "../../constants/icons";
import {useNavigate} from "react-router-dom";
import SystemAppSideBarUmmiaLogoImage from "../images/SystemAppSideBarUmmiaLogoImage";

export default function SystemAppSideBarHeader({isCollapsed, setIsCollapsed, isNarrowScreen}) {
    // Used in SystemAppSideBar to display sidebar header

    // PROPERTIES
    const navigate = useNavigate();

    // BUILD
    return (
        <div className={`w-full h-[56px] px-[16px] flex ${setFlexJustify()} items-center border-b-[1px] border-greyLight3`}>
            {isNarrowScreen || isCollapsed
                ? <SystemAppSideBarUmmiaLogoImage logoTextSize={LogoTextSize.SMALL}
                                                   onLogoPressed={() => navigate(kInternalRoutes.home)}
                                                   extraClass={"mt-[2px]"} />
                : <SystemNeoUmmiaLogoTextImage logoTextSize={LogoTextSize.SMALL}
                                               onLogoPressed={() => navigate(kInternalRoutes.home)}
                                               extraClass={"mt-[3px]"} /> }
            {displayExpandButton()
                ? <div className="cursor-pointer flex justify-center items-center text-greyLight5 hover:text-greyLight7"
                       onClick={() => setIsCollapsed(prev => !prev)}>
                    <i className={`material-icons text-[20px] ${isCollapsed ? "" : "pr-[1px]"}`}>
                        {isCollapsed ? kSystemIcons.menu : kSystemIcons.collapse}
                    </i>
                  </div>
                : null }
        </div>
    );

    // ---- UI : Set flex justify
    function setFlexJustify() {
        return isNarrowScreen ? "justify-center" : "justify-between"
    }

    // ---- UI : Display expand button in header
    function displayExpandButton() {
        return !isNarrowScreen
    }
}